import React, { useState } from "react";
import { Dialog, DialogContent, Box, Typography, Button, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const RejectModal = ({ open, onClose, onConfirm, employeeName = "Amila Bandara" }) => {
  const [reason, setReason] = useState("");

  const handleReject = () => {
    onConfirm(reason);
    setReason("");
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          padding: { xs: "20px 16px", sm: "24px 20px" },
          maxWidth: "360px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
        },
      }}
    >
      <DialogContent sx={{ p: 0, display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* Red X Icon Circle */}
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: "#EF4444",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            mb: 2,
            boxShadow: "0 6px 16px rgba(239, 68, 68, 0.3)",
          }}
        >
          <CloseIcon sx={{ fontSize: 32, stroke: "#ffffff", strokeWidth: 1 }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "#1E293B",
            fontSize: "1.2rem",
            mb: 0.5,
          }}
        >
          Reject Request
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            color: "#64748B",
            fontSize: "0.9rem",
            mb: 2,
          }}
        >
          Please provide a reason for rejection.
        </Typography>

        {/* Reason Textarea */}
        <Box sx={{ width: "100%", position: "relative", mb: 2.5 }}>
          <TextField
            multiline
            rows={4}
            fullWidth
            placeholder="Enter reason..."
            value={reason}
            onChange={(e) => {
              if (e.target.value.length <= 500) {
                setReason(e.target.value);
              }
            }}
            sx={{
              backgroundColor: "#F8FAFC",
              borderRadius: "12px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                "& fieldset": {
                  borderColor: "#E2E8F0",
                },
                "&:hover fieldset": {
                  borderColor: "#CBD5E1",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#EF4444",
                },
              },
              "& .MuiInputBase-input": {
                fontSize: "0.9rem",
                color: "#1E293B",
              },
            }}
          />
          <Typography
            sx={{
              fontSize: "0.75rem",
              color: "#94A3B8",
              textAlign: "right",
              mt: 0.5,
            }}
          >
            {reason.length}/500
          </Typography>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", width: "100%", gap: 1.5 }}>
          <Button
            fullWidth
            onClick={handleClose}
            variant="text"
            sx={{
              backgroundColor: "#F1F5F9",
              color: "#334155",
              fontWeight: 600,
              fontSize: "0.95rem",
              textTransform: "none",
              borderRadius: "12px",
              py: 1.2,
              "&:hover": {
                backgroundColor: "#E2E8F0",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            onClick={handleReject}
            variant="contained"
            sx={{
              backgroundColor: "#DC2626",
              color: "#ffffff",
              fontWeight: 600,
              fontSize: "0.95rem",
              textTransform: "none",
              borderRadius: "12px",
              py: 1.2,
              boxShadow: "0 4px 12px rgba(220, 38, 38, 0.25)",
              "&:hover": {
                backgroundColor: "#B91C1C",
              },
            }}
          >
            Reject
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RejectModal;
